
import { PropType } from 'vue'

export default {
  name: 'TabDefault',
  props: {
    title: {
      type: String as PropType<string>,
      required: true
    },
    count: {
      type: Number as PropType<number>,
      default: null
    },
    isActive: {
      type: Boolean as PropType<boolean>,
      required: true
    }
  }
}
